import React, { useState } from "react";
import "../../../CssFiles/faq.css";
export default function FAQComponent() {
  const [expanded, setExpanded] = useState(null);

  // Function to toggle the FAQ item
  const toggleFAQ = (index) => {
    setExpanded(expanded === index ? null : index);
  };
  return (
    <>
      <div id="faq-section">
        <div className="col-6 faqBox faqBox1">
          <div className="faqText">Frequently Asked Questions</div>
          <div className="haveQue">
            Have questions? We’ve got answers! Explore our comprehensive FAQ
            section to find quick and clear solutions.
          </div>
        </div>
        <div className="col-6 faqBox faqBox2">
          <div className="faq-container">
            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 1 ? "selected" : ""}`}
                onClick={() => toggleFAQ(1)}
              >
                <div>What is an unsecured business loan? </div>
                <span>{expanded === 1 ? "-" : "+"}</span>
              </div>

              {expanded === 1 && (
                <div className="faq-answer">
                  <p>
                    A business loan is a loan designed to help businesses for
                    purposes like expansion, equipment purchase, and cash flow
                    management. These loans come in various forms such as term
                    loans, lines of credit, and equipment financing. A Business
                    Loan is said to be unsecured when the loan is given without
                    any collateral against the borrowed amount. A Business Loan
                    is repaid over time along with the interest at an agreed
                    interest rate from the cash flows generated by the Business.{" "}
                  </p>
                </div>
              )}
            </div>

            <hr className="divider" />

            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 2 ? "selected" : ""}`}
                onClick={() => toggleFAQ(2)}
              >
                <div>
                  Why should I apply for a business loan from HelloTrade?
                </div>
                <span>{expanded === 2 ? "-" : "+"}</span>
              </div>
              {expanded === 2 && (
                <div className="faq-answer">
                  <p>
                    Applying for a loan from HelloTrade offers access to a vast
                    network of RBI approved lenders and competitive interest
                    rates. The application process is convenient, and we make
                    sure that we match you with lenders most likely to approve
                    your loan. We don’t charge any commission from you and hence
                    provide unbiased support and guidance throughout, ensuring
                    reliable and transparent dealings with trusted lenders.
                  </p>
                </div>
              )}
            </div>

            <hr className="divider" />

            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 3 ? "selected" : ""}`}
                onClick={() => toggleFAQ(3)}
              >
                <div>How much business loan can I get?</div>
                <span>{expanded === 3 ? "-" : "+"}</span>
              </div>
              {expanded === 3 && (
                <div className="faq-answer">
                  <p>
                    The size of a business loan is arrived at by considering
                    various factors pertaining to the business. These factors
                    include but are not limited to the turnover of the business,
                    the profit margins, existing liabilities of the business and
                    the promoters and the general financial discipline displayed
                    in the business. Hellotrade offers business loans from a few
                    lakhs to upto 1 crore.
                  </p>
                </div>
              )}
            </div>

            <hr className="divider" />

            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 4 ? "selected" : ""}`}
                onClick={() => toggleFAQ(4)}
              >
                <div>
                  What are the documents required for applying for a business
                  loan?
                </div>
                <span>{expanded === 4 ? "-" : "+"}</span>
              </div>
              {expanded === 4 && (
                <div className="faq-answer">
                  <p>
                    Typically, the following documents are required at the
                    application stage for the business and promoter(s) - KYC
                    Documents, Bank Statements, Income Tax/GST Returns, Audited
                    Financials for previous years and unaudited financials for
                    the current year, Proof of ownership of the assets, Key
                    contracts of the business. As the due diligence process goes
                    on, additional documents may be requested from the Borrower.
                  </p>
                </div>
              )}
            </div>

            <hr className="divider" />

            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 5 ? "selected" : ""}`}
                onClick={() => toggleFAQ(5)}
              >
                <div>What is the interest rate of a business loan?</div>
                <span>{expanded === 5 ? "-" : "+"}</span>
              </div>
              {expanded === 5 && (
                <div className="faq-answer">
                  <p>
                    Interest rates for business loans are competitive and start
                    at a nominal 1.25% per month.
                  </p>
                </div>
              )}
            </div>

            <hr className="divider" />

            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 6 ? "selected" : ""}`}
                onClick={() => toggleFAQ(6)}
              >
                <div>What is the time period of a business loan?</div>
                <span>{expanded === 6 ? "-" : "+"}</span>
              </div>
              {expanded === 6 && (
                <div className="faq-answer">
                  <p>We offer flexible tenure options of up to 3 years.</p>
                </div>
              )}
            </div>

            <hr className="divider" />

            <div className="faq-item">
              <div
                className={`faq-question ${expanded === 7 ? "selected" : ""}`}
                onClick={() => toggleFAQ(7)}
              >
                <div>
                  Is there a minimum and maximum age requirement for applicants
                  seeking a business loan?
                </div>
                <span>{expanded === 7 ? "-" : "+"}</span>
              </div>
              {expanded === 7 && (
                <div className="faq-answer">
                  <p>
                    Yes, there are usually minimum and maximum age requirements
                    for business loan applicants. Most lenders require
                    applicants to be at least 21 years old. The maximum age
                    limit typically ranges from 65 to 70 years old at the time
                    of loan maturity. However, age requirements can vary from
                    lender to lender.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="supercharge">
        <div className="superText">
          <span className="diff">Supercharge </span>
          Your Business with HELLOTRADE
        <div className="appNow" onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' });}}>Apply Now</div>
        </div>


      </div>
    </>
  );
}
